module.exports = new __parcel__URL__("fominLogoWithName.bac48417.png").toString();